<template>
  <order-body :isOk="false" :codeStatus="400" :pageText="'orderOut'">
  </order-body>
</template>

<script>
import orderBody from "_my/order-body";

export default {
  name: "orderOut",
  components: {
    orderBody,
  },
};
</script>
